// extracted by mini-css-extract-plugin
export var standaloneTable = "_e8-0";
export var standaloneTableWithBodyFill = "_e8-1";
export var withExtraHeader = "_e8-2";